import UserFilter from './UserFilter';
import { UserDataForm, UserFilters } from '../../../../app/models/User';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ActiveControl from '../../../../components/ActiveControl';
import UserSwitchChange from '../UserSwitchChange';

interface Props {
    users: UserDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    editPassword?: (id: number) => void;
    editMembership?: (id: number, userName: string) => void;
    active: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: UserFilters;
    setFilter: (filter: UserFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const UserDataTable = ({
    users,
    totalRows,
    loading = false,
    edit,
    editPassword,
    editMembership,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Nombre',
            selector: (row: any) => row.first_name,
            sortable: true,
            sortField: 'first_name',
            cell: (row: UserDataForm, index: any, column: any) => (
                <span className="">{row?.first_name}</span>
            )
        },
        {
            name: 'Apellido Paterno',
            selector: (row: any) => row.last_name,
            sortable: true,
            sortField: 'last_name',
            cell: (row: UserDataForm, index: any, column: any) => (
                <span className="">{row?.last_name}</span>
            )
        },
        {
            name: 'Apellido Materno',
            selector: (row: any) => row.second_last_name,
            sortable: true,
            sortField: 'second_last_name',
            cell: (row: UserDataForm, index: any, column: any) => (
                <span className="">{row.second_last_name}</span>
            )
        },
        {
            name: 'Email',
            selector: (row: any) => row.email,
            sortable: true,
            sortField: 'email',
            cell: (row: UserDataForm, index: any, column: any) => (
                <span className="">{row?.email}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: UserDataForm, index: any, column: any) => (
                <UserSwitchChange
                    checkValue={row.is_active ?? true}
                    userId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: UserDataForm, index: any, column: any) => (
                <div className="d-flex align-items-center">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            title="Ver"
                            classIcon="fa-eye"
                            colorIcon="text-info"
                            sizeIcon="16"
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            title="Editar"
                            classIcon="fa-edit"
                            colorIcon="text-warning"
                            sizeIcon="16"
                        />
                    )}
                    {editPassword && (
                        <ButtonTableAction
                            callbackFunction={() => editPassword(row.id ?? -1)}
                            title="Editar contraseña"
                            classIcon="fa-lock"
                            colorIcon="text-success"
                            sizeIcon="16"
                        />
                    )}
                    {editMembership && (
                        <ButtonTableAction
                            callbackFunction={() => editMembership(row.id ?? -1, `${row.first_name} ${row.last_name}`)}
                            title="Gestionar membresía"
                            classIcon="fa-id-card"
                            colorIcon="text-primary"
                            sizeIcon="16"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            title="Eliminar"
                            classIcon="fa-trash"
                            colorIcon="text-danger"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <UserFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={users}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default UserDataTable;
